<template>
<div class="loader">
</div>
<slot></slot>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    setup() {
        return {

        }
    }
})
</script>